import { FiltersContext } from '../context'

export const filtersActive = (filtersContext?: FiltersContext): boolean => {
  if (!filtersContext) return false

  const { activeFilters, activeDimensions, clearance } = filtersContext

  return (
    !!activeFilters.range.size ||
    !!activeFilters.colour.size ||
    !!activeFilters.seatType.size ||
    clearance
  )
}
